import ProjectSwiper from "./ProjectSwiper";
import "swiper/css";

function Portfolio() {
  return (
    <section className="bg-white py-20">
      <div className="flex flex-col gap-10 mb-10">
        <div className="container mx-auto px-4">
            <div className="flex flex-col gap-3">
              <div className="flex flex-row gap-4">
                <img src="/images/Icon/line.png" alt="Images" width={60} />
                <p className="flex justify-start items-center uppercase tracking-[2px] font-['Jost'] text-[10px] sm:text-[15px]">
                  Nos Services
                </p>
              </div>
          </div>
        </div>
        <div className="mt-10 px-3.5">
          <ProjectSwiper />
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
